import { useContext, useEffect, useMemo } from 'react'
import useDataClient from '../../hooks/useDataClient'
import { DocPage } from '../../types'
import { AppContext } from '../../context'
import CarouselContainer from './CarouselContainer'
import apiDocLogo from '../../assets/img/apidoc.png'
import { documentationAdapter } from '../../adapter'

export default function PublicCarousel() {
    const appContext = useContext(AppContext)
    const documentationClient = useDataClient<DocPage>({ appContext: appContext, disableLoading: true })
    const imagesData = useMemo(() => {
        let pageData = documentationClient.status.data || null
        const parser = new DOMParser();
        const domObject = parser.parseFromString(pageData?.content || '', "text/html");
        let images = [...domObject.getElementsByTagName('img')].map(i => `${i.src}&attachmentId=${i.getAttribute('data-linked-resource-id')}`)
        return images.length > 0 ? images.map(src => ({ content: <img src={src} alt="logo-apidocs" className='logo' /> })) : [
            { content: <img src={apiDocLogo} alt="logo-apidocs" className='logo' /> }
        ]
    }, [documentationClient.status.data]);

    useEffect(() => {
        documentationClient.executeRequest(documentationAdapter.getPublicResource())
    }, [])
    return (
        <CarouselContainer items={imagesData} />
    )
}
